import "./socials.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLinkedin,
  faGithub,
  faUpwork,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import { useEffect, useState } from "react";

export default function Socials({ inView }) {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div>
      {windowWidth >= 840 && (
        <div
          id="socials"
          className={`socials ${!inView ? "" : "socials-opacity"}`}
        >
          <div className="icon">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.linkedin.com/in/saboor7"
            >
              <FontAwesomeIcon color="black" size="xl" icon={faLinkedin} />
            </a>
          </div>
          <div className="icon">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://github.com/sabooralt"
            >
              <FontAwesomeIcon color="black" size="xl" icon={faGithub} />
            </a>
          </div>
          <div className="icon">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.upwork.com/freelancers/~012724deea79543fee"
            >
              <FontAwesomeIcon color="black" size="xl" icon={faUpwork} />
            </a>
          </div>
          <div className="icon">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://wa.me/923481807502?text=Hello%2C%20I%20am%20interested%20in%20your%20services"
            >
              <FontAwesomeIcon color="black" size="xl" icon={faWhatsapp} />
            </a>
          </div>
        </div>
      )}
    </div>
  );
}
